import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Login from "../pages/Login";
import { useAuth } from "../context/AuthContext"; // Assume you have an AuthContext

const AuthRoutes = () => {
  const { isAuthenticated } = useAuth(); // Check if the user is authenticated

  return (
    <Routes>
      {/* Redirect to / if authenticated */}
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/merge" replace /> : <Login />
        }
      />
    </Routes>
  );
};

export default AuthRoutes;
